// import React, { useState, useEffect, useCallback } from 'react';
// import { useSelector } from 'react-redux';
// import { getAllBusOwnersReport } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/BusOwnerReport.css';
// import { toast } from 'react-toastify';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Owner Name</th>
//           <th>Contact</th>
//           <th>Address</th>
//           <th>Buses</th>
//           <th>Seat Booking</th>
//           <th>Instant Booking</th>
//           <th>Razorpay</th>
//           <th>TDS</th>
//           <th>HDFC</th>
//           <th>Penalty</th>
//           <th>Refund</th>
//           <th>Payable</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const BusOwnerReport = () => {
//   const { token } = useSelector(state => state.user);
  
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingReport, setViewingReport] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   const [dateRange, setDateRange] = useState({
//     startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)
//       .toISOString().split('T')[0],
//     endDate: new Date().toISOString().split('T')[0]
//   });

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalReports, setTotalReports] = useState(0);
//   const [pageSize] = useState(10);
//   const [isLoadingMore, setIsLoadingMore] = useState(false);

//   const [stats, setStats] = useState({
//     totalOwners: 0,
//     totalBuses: 0,
//     totalSeatBooking: 0,
//     totalInstantBooking: 0,
//     totalPayable: 0,
//     totalPenalty: 0,
//     totalRefund: 0
//   });

// // Replace the getSequentialNumber function with this:
// const getSequentialNumber = (index, page) => {
//   return (page - 1) * pageSize + index + 1;
// };

//   const calculateStats = (data) => {
//     if (!data || data.length === 0) {
//       setStats({
//         totalOwners: 0,
//         totalBuses: 0,
//         totalSeatBooking: 0,
//         totalInstantBooking: 0,
//         totalPayable: 0,
//         totalPenalty: 0,
//         totalRefund: 0
//       });
//       return;
//     }

//     const totalSeatBooking = data.reduce((sum, item) => sum + (item.seatBooking || 0), 0);
//     const totalInstantBooking = data.reduce((sum, item) => sum + (item.instantBooking || 0), 0);
//     const totalPayable = data.reduce((sum, item) => sum + (item.payableAmount || 0), 0);
//     const totalPenalty = data.reduce((sum, item) => sum + (item.penalty || 0), 0);
//     const totalRefund = data.reduce((sum, item) => sum + (item.refund || 0), 0);
//     const totalBuses = data.reduce((sum, item) => sum + (item.noOfBuses || 0), 0);

//     setStats({
//       totalOwners: data.length,
//       totalBuses,
//       totalSeatBooking,
//       totalInstantBooking,
//       totalPayable,
//       totalPenalty,
//       totalRefund
//     });
//   };
// const fetchReports = useCallback(async (page = 1) => {
//   try {
//     if (page === 1) {
//       setLoading(true);
//     } else {
//       setIsLoadingMore(true);
//     }
//     setError(null);

//     const response = await getAllBusOwnersReport(
//       token,
//       dateRange.startDate,
//       dateRange.endDate,
//       null,
//       page,
//       pageSize,
//       searchTerm
//     );

//     console.log('Bus Owner Report Response:', response);

//     if (response && response.success) {
//       // ✅ Pass the page parameter to getSequentialNumber
//       const transformedReports = response.data.map((report, index) => ({
//         id: `${page}-${index}`,
//         serialNo: getSequentialNumber(index, page), // ← Pass page here
//         ownerName: report['Bus Owners Name'] || '',
//         contractNumber: report['Contract Number'] || '',
//         address: report['Address'] || '',
//         noOfBuses: report['No. Of Buses'] || 0,
//         seatBooking: report['Seat Booking'] || 0,
//         instantBooking: report['Intant Booking'] || 0,
//         razorpay: report['Razorpay(Deduction)'] || 0,
//         tds: report['TDS(Deduction)'] || 0,
//         hdfc: report['HDFC Deduction'] || 0,
//         penalty: report['Penaulty to Customer'] || 0,
//         cgst: report['CGST'] || 0,
//         sgst: report['SGST'] || 0,
//         igst: report['IGST'] || 0,
//         refund: report['Refund to Customer'] || 0,
//         payableAmount: report['Payable Amount'] || 0,
//         perBus: report._perBus || []
//       }));

//       setReports(transformedReports);
      
//       const total = response.pagination?.totalItems || response.total || response.count || 0;
//       setTotalReports(total);
      
//       const pages = response.pagination?.totalPages || Math.ceil(total / pageSize) || 1;
//       setTotalPages(pages);
//       setCurrentPage(response.pagination?.currentPage || page);

//       // Always use stats from backend response
//       if (response.stats) {
//         setStats({
//           totalOwners: response.stats.totalOwners || 0,
//           totalBuses: response.stats.totalBuses || 0,
//           totalSeatBooking: response.stats.totalSeatBooking || 0,
//           totalInstantBooking: response.stats.totalInstantBooking || 0,
//           totalPayable: response.stats.totalPayable || 0,
//           totalPenalty: response.stats.totalPenalty || 0,
//           totalRefund: response.stats.totalRefund || 0
//         });
//       } else {
//         calculateStats(transformedReports);
//       }
//     } else {
//       setReports([]);
//       setTotalReports(0);
//       setTotalPages(1);
//       setStats({
//         totalOwners: 0,
//         totalBuses: 0,
//         totalSeatBooking: 0,
//         totalInstantBooking: 0,
//         totalPayable: 0,
//         totalPenalty: 0,
//         totalRefund: 0
//       });
//     }
//   } catch (err) {
//     console.error('Error fetching bus owners report:', err);
//     setError(err.response?.data?.message || 'Failed to fetch bus owners report. Please try again.');
//     toast.error('Failed to fetch bus owners report');
//   } finally {
//     setLoading(false);
//     setIsLoadingMore(false);
//   }
// }, [token, dateRange.startDate, dateRange.endDate, searchTerm, pageSize]);

//   const handleViewReport = async (ownerName) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);

//       const owner = reports.find(r => r.ownerName === ownerName);
//       if (!owner) {
//         toast.warning('Owner not found in the current report');
//         setViewingReport(null);
//         return;
//       }

//       setViewingReport(owner);
//     } catch (err) {
//       console.error('Error fetching bus owner report details:', err);
//       setError('Failed to fetch bus owner report details.');
//       toast.error('Failed to fetch bus owner report details');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingReport(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleRefresh = () => {
//     fetchReports(1);
//   };

//   const handleExportCSV = () => {
//     if (reports.length === 0) {
//       toast.warning('No data to export');
//       return;
//     }

//     const headers = [
//       'Serial No.',
//       'Owner Name',
//       'Contact',
//       'Address',
//       'No. Of Buses',
//       'Seat Booking',
//       'Instant Booking',
//       'Razorpay',
//       'TDS',
//       'HDFC',
//       'Penalty',
//       'CGST',
//       'SGST',
//       'IGST',
//       'Refund',
//       'Payable Amount'
//     ];

//     const csvData = reports.map(report => [
//       report.serialNo,
//       `"${report.ownerName || ''}"`,
//       `"${report.contractNumber || ''}"`,
//       `"${report.address || ''}"`,
//       report.noOfBuses,
//       (report.seatBooking || 0).toFixed(2),
//       (report.instantBooking || 0).toFixed(2),
//       (report.razorpay || 0).toFixed(2),
//       (report.tds || 0).toFixed(2),
//       (report.hdfc || 0).toFixed(2),
//       (report.penalty || 0).toFixed(2),
//       (report.cgst || 0).toFixed(2),
//       (report.sgst || 0).toFixed(2),
//       (report.igst || 0).toFixed(2),
//       (report.refund || 0).toFixed(2),
//       (report.payableAmount || 0).toFixed(2)
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `bus-owner-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     toast.success('CSV exported successfully!');
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber !== currentPage && pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//       fetchReports(pageNumber);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       const nextPage = currentPage + 1;
//       setCurrentPage(nextPage);
//       fetchReports(nextPage);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       const prevPage = currentPage - 1;
//       setCurrentPage(prevPage);
//       fetchReports(prevPage);
//     }
//   };

//   // Debounce search
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (searchTerm.trim() !== '' || currentPage === 1) {
//         fetchReports(1);
//       }
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [searchTerm]);

//   // Fetch on date range change
//   useEffect(() => {
//     fetchReports(1);
//   }, [dateRange.startDate, dateRange.endDate]);

//   // Render pagination component
//   const renderPagination = () => {
//     if (totalPages <= 1) return null;

//     const maxVisiblePages = 5;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage < maxVisiblePages - 1) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     const pages = [];
//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(i);
//     }

//     return (
//       <div className="pagination-container" style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginTop: '20px',
//         padding: '10px 0',
//         flexWrap: 'wrap',
//         gap: '10px'
//       }}>
//         <div className="pagination-info" style={{ fontSize: '14px', color: '#666' }}>
//           Showing {reports.length} of {totalReports} bus owners
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator" style={{ marginLeft: '10px', color: '#888' }}> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls" style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1 || isLoadingMore}
//             style={{
//               padding: '6px 12px',
//               border: '1px solid #ddd',
//               borderRadius: '4px',
//               backgroundColor: currentPage === 1 || isLoadingMore ? '#f5f5f5' : 'white',
//               cursor: currentPage === 1 || isLoadingMore ? 'not-allowed' : 'pointer',
//               color: currentPage === 1 || isLoadingMore ? '#999' : '#333'
//             }}
//           >
//             Previous
//           </button>

//           {startPage > 1 && (
//             <>
//               <button
//                 className="page-number"
//                 onClick={() => handlePageChange(1)}
//                 disabled={isLoadingMore}
//                 style={{
//                   padding: '6px 12px',
//                   border: '1px solid #ddd',
//                   borderRadius: '4px',
//                   backgroundColor: 'white',
//                   color: '#333',
//                   cursor: isLoadingMore ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 1
//               </button>
//               {startPage > 2 && <span style={{ padding: '6px 4px', color: '#999' }}>...</span>}
//             </>
//           )}

//           {pages.map(pageNumber => (
//             <button
//               key={pageNumber}
//               className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//               onClick={() => handlePageChange(pageNumber)}
//               disabled={isLoadingMore}
//               style={{
//                 padding: '6px 12px',
//                 border: pageNumber === currentPage ? '2px solid #007bff' : '1px solid #ddd',
//                 borderRadius: '4px',
//                 backgroundColor: pageNumber === currentPage ? '#007bff' : 'white',
//                 color: pageNumber === currentPage ? 'white' : '#333',
//                 cursor: isLoadingMore ? 'not-allowed' : 'pointer',
//                 fontWeight: pageNumber === currentPage ? 'bold' : 'normal'
//               }}
//             >
//               {pageNumber}
//             </button>
//           ))}

//           {endPage < totalPages && (
//             <>
//               {endPage < totalPages - 1 && <span style={{ padding: '6px 4px', color: '#999' }}>...</span>}
//               <button
//                 className="page-number"
//                 onClick={() => handlePageChange(totalPages)}
//                 disabled={isLoadingMore}
//                 style={{
//                   padding: '6px 12px',
//                   border: '1px solid #ddd',
//                   borderRadius: '4px',
//                   backgroundColor: 'white',
//                   color: '#333',
//                   cursor: isLoadingMore ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 {totalPages}
//               </button>
//             </>
//           )}

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages || isLoadingMore}
//             style={{
//               padding: '6px 12px',
//               border: '1px solid #ddd',
//               borderRadius: '4px',
//               backgroundColor: currentPage === totalPages || isLoadingMore ? '#f5f5f5' : 'white',
//               cursor: currentPage === totalPages || isLoadingMore ? 'not-allowed' : 'pointer',
//               color: currentPage === totalPages || isLoadingMore ? '#999' : '#333'
//             }}
//           >
//             Next
//           </button>

//           {isLoadingMore && (
//             <span style={{ marginLeft: '10px', color: '#666' }}>
//               <span className="loading-spinner" style={{ 
//                 display: 'inline-block', 
//                 width: '16px', 
//                 height: '16px', 
//                 border: '2px solid #f3f3f3', 
//                 borderTop: '2px solid #007bff', 
//                 borderRadius: '50%', 
//                 animation: 'spin 1s linear infinite' 
//               }}></span>
//             </span>
//           )}
//         </div>
//       </div>
//     );
//   };

//   if (loading && reports.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page bus-owner-report-page">
//       <div className="page-header">
//         <h1>Bus Owner Report</h1>
//         <div className="header-actions">
//           <div className="filters-group">
//             <div className="date-filters">
//               <label>
//                 Start Date:
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={dateRange.startDate}
//                   onChange={handleDateChange}
//                   className="date-input"
//                 />
//               </label>
//               <label>
//                 End Date:
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={dateRange.endDate}
//                   onChange={handleDateChange}
//                   className="date-input"
//                 />
//               </label>
//             </div>
//             <input
//               type="text"
//               placeholder="Search by owner name, contact or address..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "250px" }}
//             />
//           </div>

//           <button className="refresh-btn" onClick={handleRefresh} disabled={loading}>
//             🔄 Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             📊 Export CSV
//           </button>
//         </div>
//       </div>

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Total Reports: {totalReports} | Page {currentPage} of {totalPages} | 
//         Date Range: {dateRange.startDate} to {dateRange.endDate}
//         {searchTerm && ` | Search: "${searchTerm}"`}
//       </div>

//       {error && (
//         <div className="error-message" style={{
//           backgroundColor: '#f8d7da',
//           color: '#721c24',
//           padding: '10px',
//           borderRadius: '4px',
//           marginBottom: '15px'
//         }}>
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Owners</h3>
//           <p>{stats.totalOwners}</p>
//           <span>Bus owners in report</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{stats.totalBuses}</p>
//           <span>Total buses across all owners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Seat Booking</h3>
//           <p>₹{stats.totalSeatBooking.toFixed(2)}</p>
//           <span>Total seat bookings</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Instant Booking</h3>
//           <p>₹{stats.totalInstantBooking.toFixed(2)}</p>
//           <span>Total instant bookings</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Payable</h3>
//           <p>₹{stats.totalPayable.toFixed(2)}</p>
//           <span>Total payable amount</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Penalty</h3>
//           <p>₹{stats.totalPenalty.toFixed(2)}</p>
//           <span>Total penalty amount</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Refund</h3>
//           <p>₹{stats.totalRefund.toFixed(2)}</p>
//           <span>Total refund amount</span>
//         </div>
//       </div>

//       <div className="table-container" style={{ overflowX: 'auto' }}>
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Owner Name</th>
//               <th>Contact</th>
//               <th>Address</th>
//               <th>Buses</th>
//               <th>Seat Booking</th>
//               <th>Instant Booking</th>
//               <th>Razorpay</th>
//               <th>TDS</th>
//               <th>HDFC</th>
//               <th>Penalty</th>
//               <th>Refund</th>
//               <th>Payable</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {reports.length > 0 ? (
//               reports.map((report) => (
//                 <tr key={report.id}>
//                   <td>{report.serialNo}</td>
//                   <td>
//                     <strong>{report.ownerName}</strong>
//                     {report.noOfBuses > 0 && (
//                       <div className="bus-count">
//                         <small>{report.noOfBuses} bus{report.noOfBuses > 1 ? 'es' : ''}</small>
//                       </div>
//                     )}
//                   </td>
//                   <td>{report.contractNumber}</td>
//                   <td>
//                     <div className="address-info" title={report.address}>
//                       {report.address.length > 30 ? 
//                         `${report.address.substring(0, 30)}...` : 
//                         report.address}
//                     </div>
//                   </td>
//                   <td>
//                     <span className="bus-count-badge">
//                       {report.noOfBuses}
//                     </span>
//                   </td>
//                   <td>₹{report.seatBooking.toFixed(2)}</td>
//                   <td>₹{report.instantBooking.toFixed(2)}</td>
//                   <td>₹{report.razorpay.toFixed(2)}</td>
//                   <td>₹{report.tds.toFixed(2)}</td>
//                   <td>₹{report.hdfc.toFixed(2)}</td>
//                   <td>
//                     <span className={`penalty-amount ${report.penalty > 0 ? 'has-penalty' : ''}`}>
//                       ₹{report.penalty.toFixed(2)}
//                     </span>
//                   </td>
//                   <td>
//                     <span className={`refund-amount ${report.refund > 0 ? 'has-refund' : ''}`}>
//                       ₹{report.refund.toFixed(2)}
//                     </span>
//                   </td>
//                   <td>
//                     <span className="payable-amount">
//                       ₹{report.payableAmount.toFixed(2)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewReport(report.ownerName)}
//                       >
//                         View Details
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="14" className="no-data" style={{ textAlign: 'center', padding: '40px' }}>
//                   <p>
//                     {searchTerm 
//                       ? 'No bus owners found matching your search.' 
//                       : 'No bus owner reports available for the selected date range.'}
//                   </p>
//                   {searchTerm && (
//                     <button 
//                       className="clear-filters-link" 
//                       onClick={() => setSearchTerm('')}
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#007bff',
//                         cursor: 'pointer',
//                         textDecoration: 'underline'
//                       }}
//                     >
//                       Clear search to see all owners
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {renderPagination()}

//       {viewingReport && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal} style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           zIndex: 1000
//         }}>
//           <div className="modal-content1 bus-owner-report-modal" onClick={(e) => e.stopPropagation()} style={{
//             backgroundColor: 'white',
//             borderRadius: '8px',
//             maxWidth: '800px',
//             width: '90%',
//             maxHeight: '90vh',
//             overflow: 'auto',
//             padding: '20px'
//           }}>
//             <div className="modal-header" style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               borderBottom: '1px solid #eee',
//               paddingBottom: '15px',
//               marginBottom: '20px'
//             }}>
//               <h3 style={{ margin: 0 }}>Bus Owner Report Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal} style={{
//                 background: 'none',
//                 border: 'none',
//                 fontSize: '24px',
//                 cursor: 'pointer',
//                 color: '#666'
//               }}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="report-details">
//                 <div className="report-header" style={{ 
//                   textAlign: 'center', 
//                   paddingBottom: '15px', 
//                   borderBottom: '2px solid #f0f0f0', 
//                   marginBottom: '20px' 
//                 }}>
//                   <h2 style={{ margin: '0 0 5px 0' }}>{viewingReport.ownerName}</h2>
//                   <p style={{ color: '#666', margin: '5px 0' }}>📞 {viewingReport.contractNumber}</p>
//                   <p style={{ color: '#888', margin: '5px 0', fontSize: '14px' }}>{viewingReport.address}</p>
//                   <span className="bus-count-badge" style={{
//                     display: 'inline-block',
//                     padding: '4px 12px',
//                     borderRadius: '12px',
//                     fontSize: '12px',
//                     fontWeight: '600',
//                     backgroundColor: '#007bff',
//                     color: 'white'
//                   }}>
//                     🚌 {viewingReport.noOfBuses} Bus{viewingReport.noOfBuses > 1 ? 'es' : ''}
//                   </span>
//                 </div>

//                 <div className="report-section" style={{ marginBottom: '20px' }}>
//                   <h4 style={{ fontSize: '15px', color: '#555', marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
//                     Financial Summary
//                   </h4>
//                   <div className="detail-grid" style={{ 
//                     display: 'grid', 
//                     gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
//                     gap: '12px' 
//                   }}>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>Total Seat Booking</label>
//                       <span className="amount" style={{ fontSize: '16px', fontWeight: '600', display: 'block' }}>₹{viewingReport.seatBooking.toFixed(2)}</span>
//                     </div>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>Total Instant Booking</label>
//                       <span className="amount" style={{ fontSize: '16px', fontWeight: '600', display: 'block' }}>₹{viewingReport.instantBooking.toFixed(2)}</span>
//                     </div>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>Total Gross</label>
//                       <span className="amount" style={{ fontSize: '16px', fontWeight: '600', display: 'block' }}>
//                         ₹{(viewingReport.seatBooking + viewingReport.instantBooking).toFixed(2)}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="report-section" style={{ marginBottom: '20px' }}>
//                   <h4 style={{ fontSize: '15px', color: '#555', marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
//                     Deductions
//                   </h4>
//                   <div className="detail-grid" style={{ 
//                     display: 'grid', 
//                     gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
//                     gap: '12px' 
//                   }}>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>Razorpay</label>
//                       <span className="amount deduction" style={{ fontSize: '16px', fontWeight: '600', display: 'block', color: '#dc3545' }}>₹{viewingReport.razorpay.toFixed(2)}</span>
//                     </div>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>TDS</label>
//                       <span className="amount deduction" style={{ fontSize: '16px', fontWeight: '600', display: 'block', color: '#dc3545' }}>₹{viewingReport.tds.toFixed(2)}</span>
//                     </div>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>HDFC</label>
//                       <span className="amount deduction" style={{ fontSize: '16px', fontWeight: '600', display: 'block', color: '#dc3545' }}>₹{viewingReport.hdfc.toFixed(2)}</span>
//                     </div>
//                     <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                       <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>Penalty</label>
//                       <span className={`amount ${viewingReport.penalty > 0 ? 'deduction' : ''}`} style={{ 
//                         fontSize: '16px', 
//                         fontWeight: '600', 
//                         display: 'block',
//                         color: viewingReport.penalty > 0 ? '#dc3545' : '#333'
//                       }}>
//                         ₹{viewingReport.penalty.toFixed(2)}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {(viewingReport.cgst > 0 || viewingReport.sgst > 0 || viewingReport.igst > 0) && (
//                   <div className="report-section" style={{ marginBottom: '20px' }}>
//                     <h4 style={{ fontSize: '15px', color: '#555', marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
//                       Tax Summary
//                     </h4>
//                     <div className="detail-grid" style={{ 
//                       display: 'grid', 
//                       gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
//                       gap: '12px' 
//                     }}>
//                       {viewingReport.cgst > 0 && (
//                         <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                           <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>CGST</label>
//                           <span className="amount tax" style={{ fontSize: '16px', fontWeight: '600', display: 'block', color: '#17a2b8' }}>₹{viewingReport.cgst.toFixed(2)}</span>
//                         </div>
//                       )}
//                       {viewingReport.sgst > 0 && (
//                         <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                           <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>SGST</label>
//                           <span className="amount tax" style={{ fontSize: '16px', fontWeight: '600', display: 'block', color: '#17a2b8' }}>₹{viewingReport.sgst.toFixed(2)}</span>
//                         </div>
//                       )}
//                       {viewingReport.igst > 0 && (
//                         <div className="detail-item" style={{ background: '#f8f9fa', padding: '10px 12px', borderRadius: '6px' }}>
//                           <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '3px' }}>IGST</label>
//                           <span className="amount tax" style={{ fontSize: '16px', fontWeight: '600', display: 'block', color: '#17a2b8' }}>₹{viewingReport.igst.toFixed(2)}</span>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 <div className="report-section" style={{ marginBottom: '20px' }}>
//                   <h4 style={{ fontSize: '15px', color: '#555', marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
//                     Refund Information
//                   </h4>
//                   <div className="detail-row" style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
//                     <label style={{ fontWeight: '500', color: '#555' }}>Refund to Customer:</label>
//                     <span className={`amount ${viewingReport.refund > 0 ? 'refund' : ''}`} style={{ 
//                       fontWeight: '600',
//                       color: viewingReport.refund > 0 ? '#28a745' : '#333'
//                     }}>
//                       ₹{viewingReport.refund.toFixed(2)}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="report-section total-section" style={{ 
//                   background: '#f8f9fa', 
//                   padding: '15px', 
//                   borderRadius: '8px', 
//                   borderLeft: '4px solid #28a745',
//                   marginBottom: '20px'
//                 }}>
//                   <div className="detail-row total" style={{ 
//                     display: 'flex', 
//                     justifyContent: 'space-between', 
//                     padding: '10px 0',
//                     borderBottom: 'none'
//                   }}>
//                     <label style={{ fontSize: '18px', fontWeight: '600', color: '#333' }}>Total Payable Amount:</label>
//                     <span className="total-amount" style={{ fontSize: '24px', fontWeight: 'bold', color: '#28a745' }}>
//                       ₹{viewingReport.payableAmount.toFixed(2)}
//                     </span>
//                   </div>
//                 </div>

//                 {viewingReport.perBus && viewingReport.perBus.length > 0 && (
//                   <div className="report-section" style={{ marginBottom: '20px' }}>
//                     <h4 style={{ fontSize: '15px', color: '#555', marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
//                       Per Bus Breakdown ({viewingReport.perBus.length} buses)
//                     </h4>
//                     <div className="per-bus-list" style={{ 
//                       maxHeight: '200px', 
//                       overflowY: 'auto',
//                       border: '1px solid #eee',
//                       borderRadius: '4px'
//                     }}>
//                       <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
//                         <thead style={{ backgroundColor: '#f8f9fa', position: 'sticky', top: 0 }}>
//                           <tr>
//                             <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Bus</th>
//                             <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Registration</th>
//                             <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Type</th>
//                             <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #ddd' }}>Payable</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {viewingReport.perBus.map((bus, idx) => (
//                             <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0' }}>
//                               <td style={{ padding: '8px' }}>{bus.busDetails}</td>
//                               <td style={{ padding: '8px' }}>{bus.busRegistration}</td>
//                               <td style={{ padding: '8px' }}>
//                                 <span className={`bus-type-badge ${bus.busType === 'AC' ? 'ac' : 'non-ac'}`} style={{
//                                   display: 'inline-block',
//                                   padding: '2px 8px',
//                                   borderRadius: '10px',
//                                   fontSize: '10px',
//                                   fontWeight: '600',
//                                   backgroundColor: bus.busType === 'AC' ? '#d4edda' : '#f8d7da',
//                                   color: bus.busType === 'AC' ? '#155724' : '#721c24'
//                                 }}>
//                                   {bus.busType}
//                                 </span>
//                               </td>
//                               <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600', color: '#28a745' }}>
//                                 ₹{bus.payableAmount.toFixed(2)}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer" style={{
//               display: 'flex',
//               justifyContent: 'flex-end',
//               paddingTop: '15px',
//               borderTop: '1px solid #eee',
//               marginTop: '10px'
//             }}>
//               <button className="modal-close-btn secondary" onClick={closeViewModal} style={{
//                 padding: '8px 20px',
//                 backgroundColor: '#6c757d',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '4px',
//                 cursor: 'pointer'
//               }}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {viewingReport && isFetchingDetails && (
//         <div className="modal-overlay">
//           <div className="modal-content1 skeleton-modal">
//             <div className="modal-header">
//               <div className="skeleton-title"></div>
//               <div className="skeleton-close"></div>
//             </div>
//             <div className="modal-body">
//               <div className="skeleton-profile-image"></div>
//               {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//                 <div key={i} className="skeleton-detail-row">
//                   <div className="skeleton-label"></div>
//                   <div className="skeleton-value"></div>
//                 </div>
//               ))}
//             </div>
//             <div className="modal-footer">
//               <div className="skeleton-button"></div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BusOwnerReport;

import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getAllBusOwnersReport } from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/BusOwnerReport.css';       // bus-owner-report-only additions (load LAST)
import { toast } from 'react-toastify';
import { Icon, BusSvg, StatCard, Avatar, Pagination, Field } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const fmtINR = (v) => `₹${Number(v || 0).toFixed(2)}`;

// ============================================================
// MAIN
// ============================================================
const BusOwnerReport = () => {
  const { token } = useSelector(state => state.user);

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingReport, setViewingReport] = useState(null);
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [layout, setLayout] = useState('table');

  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalReports, setTotalReports] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [stats, setStats] = useState({
    totalOwners: 0, totalBuses: 0, totalSeatBooking: 0, totalInstantBooking: 0,
    totalPayable: 0, totalPenalty: 0, totalRefund: 0
  });

  const getSequentialNumber = (index, page) => (page - 1) * pageSize + index + 1;

  const calculateStats = (data) => {
    if (!data || data.length === 0) {
      setStats({ totalOwners: 0, totalBuses: 0, totalSeatBooking: 0, totalInstantBooking: 0, totalPayable: 0, totalPenalty: 0, totalRefund: 0 });
      return;
    }
    const totalSeatBooking = data.reduce((sum, item) => sum + (item.seatBooking || 0), 0);
    const totalInstantBooking = data.reduce((sum, item) => sum + (item.instantBooking || 0), 0);
    const totalPayable = data.reduce((sum, item) => sum + (item.payableAmount || 0), 0);
    const totalPenalty = data.reduce((sum, item) => sum + (item.penalty || 0), 0);
    const totalRefund = data.reduce((sum, item) => sum + (item.refund || 0), 0);
    const totalBuses = data.reduce((sum, item) => sum + (item.noOfBuses || 0), 0);
    setStats({ totalOwners: data.length, totalBuses, totalSeatBooking, totalInstantBooking, totalPayable, totalPenalty, totalRefund });
  };

  const fetchReports = useCallback(async (page = 1) => {
    try {
      if (page === 1) setLoading(true); else setIsLoadingMore(true);
      setError(null);

      const response = await getAllBusOwnersReport(
        token, dateRange.startDate, dateRange.endDate, null, page, pageSize, searchTerm
      );

      if (response && response.success) {
        const transformedReports = response.data.map((report, index) => ({
          id: `${page}-${index}`,
          serialNo: getSequentialNumber(index, page),
          ownerName: report['Bus Owners Name'] || '',
          contractNumber: report['Contract Number'] || '',
          address: report['Address'] || '',
          noOfBuses: report['No. Of Buses'] || 0,
          seatBooking: report['Seat Booking'] || 0,
          instantBooking: report['Intant Booking'] || 0,
          razorpay: report['Razorpay(Deduction)'] || 0,
          tds: report['TDS(Deduction)'] || 0,
          hdfc: report['HDFC Deduction'] || 0,
          penalty: report['Penaulty to Customer'] || 0,
          cgst: report['CGST'] || 0,
          sgst: report['SGST'] || 0,
          igst: report['IGST'] || 0,
          refund: report['Refund to Customer'] || 0,
          payableAmount: report['Payable Amount'] || 0,
          perBus: report._perBus || []
        }));

        setReports(transformedReports);
        const total = response.pagination?.totalItems || response.total || response.count || 0;
        setTotalReports(total);
        const pages = response.pagination?.totalPages || Math.ceil(total / pageSize) || 1;
        setTotalPages(pages);
        setCurrentPage(response.pagination?.currentPage || page);

        if (response.stats) {
          setStats({
            totalOwners: response.stats.totalOwners || 0,
            totalBuses: response.stats.totalBuses || 0,
            totalSeatBooking: response.stats.totalSeatBooking || 0,
            totalInstantBooking: response.stats.totalInstantBooking || 0,
            totalPayable: response.stats.totalPayable || 0,
            totalPenalty: response.stats.totalPenalty || 0,
            totalRefund: response.stats.totalRefund || 0
          });
        } else {
          calculateStats(transformedReports);
        }
      } else {
        setReports([]); setTotalReports(0); setTotalPages(1);
        setStats({ totalOwners: 0, totalBuses: 0, totalSeatBooking: 0, totalInstantBooking: 0, totalPayable: 0, totalPenalty: 0, totalRefund: 0 });
      }
    } catch (err) {
      console.error('Error fetching bus owners report:', err);
      setError(err.response?.data?.message || 'Failed to fetch bus owners report. Please try again.');
      toast.error('Failed to fetch bus owners report');
    } finally {
      setLoading(false); setIsLoadingMore(false); setFirstLoad(false);
    }
  }, [token, dateRange.startDate, dateRange.endDate, searchTerm, pageSize]);

  const handleViewReport = async (ownerName) => {
    try {
      setIsFetchingDetails(true); setError(null);
      const owner = reports.find(r => r.ownerName === ownerName);
      if (!owner) { toast.warning('Owner not found in the current report'); setViewingReport(null); return; }
      setViewingReport(owner);
    } catch (err) {
      console.error('Error fetching bus owner report details:', err);
      setError('Failed to fetch bus owner report details.');
      toast.error('Failed to fetch bus owner report details');
    } finally { setIsFetchingDetails(false); }
  };

  const closeViewModal = () => setViewingReport(null);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange(prev => ({ ...prev, [name]: value }));
  };

  const handleRefresh = () => { fetchReports(1); };

  const handleExportCSV = () => {
    if (reports.length === 0) { toast.warning('No data to export'); return; }
    const headers = ['Serial No.', 'Owner Name', 'Contact', 'Address', 'No. Of Buses', 'Seat Booking', 'Instant Booking', 'Razorpay', 'TDS', 'HDFC', 'Penalty', 'CGST', 'SGST', 'IGST', 'Refund', 'Payable Amount'];
    const csvData = reports.map(report => [
      report.serialNo, `"${report.ownerName || ''}"`, `"${report.contractNumber || ''}"`, `"${report.address || ''}"`,
      report.noOfBuses, (report.seatBooking || 0).toFixed(2), (report.instantBooking || 0).toFixed(2),
      (report.razorpay || 0).toFixed(2), (report.tds || 0).toFixed(2), (report.hdfc || 0).toFixed(2),
      (report.penalty || 0).toFixed(2), (report.cgst || 0).toFixed(2), (report.sgst || 0).toFixed(2),
      (report.igst || 0).toFixed(2), (report.refund || 0).toFixed(2), (report.payableAmount || 0).toFixed(2)
    ]);
    const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `bus-owner-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link); link.click(); document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully!');
  };

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm.trim() !== '' || currentPage === 1) fetchReports(1);
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  // Fetch on date range change
  useEffect(() => {
    fetchReports(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange.startDate, dateRange.endDate]);

  // ============================================================
  if (firstLoad && loading && reports.length === 0) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Reports</span>
          <h1>Bus Owner Report</h1><p>Loading reports…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Owner Financial Insights</span>
          <h1>Bus Owner Report</h1>
          <p>Aggregated financial breakdown for each bus owner across their entire fleet.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input type="text" placeholder="Search by owner name, contact or address…" value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh" disabled={loading}><Icon name="refresh" size={17} /></button>
          <button className="prm-add-btn" onClick={handleExportCSV}>
            <span className="plus"><Icon name="download" size={14} /></span> Export CSV
          </button>
        </div>
      </div>

      {error && <div className="bor-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={handleRefresh}>Retry</button></div>}

      {/* DATE FILTER STRIP */}
      <div className="bor-filter-strip">
        <Field label="Start Date">
          <input type="date" name="startDate" value={dateRange.startDate} onChange={handleDateChange} className="prm-input" />
        </Field>
        <Field label="End Date">
          <input type="date" name="endDate" value={dateRange.endDate} onChange={handleDateChange} className="prm-input" />
        </Field>
        <div className="bor-filter-info">
          <Icon name="calendar" size={14} /> {totalReports} reports · {formatDateDMY(dateRange.startDate)} → {formatDateDMY(dateRange.endDate)}
        </div>
      </div>

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="users" tone="indigo" label="Total Owners" value={stats.totalOwners} hint="Bus owners in report" delay={80} />
        <StatCard icon="bus" tone="green" label="Total Buses" value={stats.totalBuses} hint="Across all owners" delay={140} />
        <StatCard icon="check" tone="amber" label="Seat Bookings" value={fmtINR(stats.totalSeatBooking)} hint="Total seat booking amount" delay={200} />
        <StatCard icon="ticket" tone="cyan" label="Instant Bookings" value={fmtINR(stats.totalInstantBooking)} hint="Total instant booking amount" delay={260} />
        <StatCard icon="wallet" tone="indigo" label="Payable Amount" value={fmtINR(stats.totalPayable)} hint="Net payable to owners" delay={320} />
        <StatCard icon="info" tone="red" label="Penalty" value={fmtINR(stats.totalPenalty)} hint="Penalty to customers" delay={380} />
        <StatCard icon="refresh" tone="amber" label="Refund" value={fmtINR(stats.totalRefund)} hint="Refunded to customers" delay={440} />
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button className={`prm-chip ${layout === 'table' ? 'active' : ''}`} onClick={() => setLayout('table')}>Table</button>
            <button className={`prm-chip ${layout === 'cards' ? 'active' : ''}`} onClick={() => setLayout('cards')}>Cards</button>
          </div>
          {searchTerm && <span className="prm-tag amber">Search: "{searchTerm}"</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{reports.length}</b> of {totalReports}</span>
        </div>
      </div>

      {/* LIST */}
      <div className={(loading || isLoadingMore) ? 'bor-loading' : ''}>
        {reports.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm ? 'search' : 'users'} size={44} /></div>
            <h3>{searchTerm ? 'No owners match your search' : 'No bus owner reports available'}</h3>
            <p>{searchTerm ? 'Try a different search term or clear the search.' : 'No reports found for the selected date range.'}</p>
            {searchTerm && <button className="prm-btn ghost" onClick={() => setSearchTerm('')}>Clear search</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {reports.map((report, i) => (
              <div key={report.id} className="prm-card bor-card" style={{ animationDelay: `${i * 60}ms` }}>
                <div className="prm-card-top">
                  <div className="pbo-owner-id">
                    <Avatar name={report.ownerName} size={52} />
                    <div>
                      <div className="prm-card-no">Owner #{String(report.serialNo).padStart(2, '0')}</div>
                      <h3 className="prm-card-title">{report.ownerName || 'N/A'}</h3>
                      <div className="prm-card-sub"><Icon name="phone" size={14} /> {report.contractNumber || 'N/A'}</div>
                    </div>
                  </div>
                  <span className="prm-status active">{report.noOfBuses} {report.noOfBuses === 1 ? 'Bus' : 'Buses'}</span>
                </div>
                <div className="pbo-contact">
                  <div><Icon name="map" size={14} /> {report.address || 'N/A'}</div>
                </div>
                <div className="bor-metrics-grid">
                  <div><small>Seat</small><b className="bor-pos">{fmtINR(report.seatBooking)}</b></div>
                  <div><small>Instant</small><b className="bor-pos">{fmtINR(report.instantBooking)}</b></div>
                  <div><small>Razorpay</small><b className="bor-neg">{fmtINR(report.razorpay)}</b></div>
                  <div><small>TDS</small><b className="bor-neg">{fmtINR(report.tds)}</b></div>
                  <div><small>HDFC</small><b className="bor-neg">{fmtINR(report.hdfc)}</b></div>
                  <div><small>Penalty</small><b className={report.penalty > 0 ? 'bor-neg' : ''}>{fmtINR(report.penalty)}</b></div>
                  <div><small>Refund</small><b className={report.refund > 0 ? 'bor-neg' : ''}>{fmtINR(report.refund)}</b></div>
                  <div><small>Payable</small><b className="bor-total">{fmtINR(report.payableAmount)}</b></div>
                </div>
                <div className="pbo-card-actions">
                  <button className="prm-btn view sm" onClick={() => handleViewReport(report.ownerName)}>
                    <Icon name="eye" size={14} /> View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th>No.</th><th>Owner</th><th>Contact</th><th>Address</th><th>Buses</th>
                  <th>Seat</th><th>Instant</th><th>Razorpay</th><th>TDS</th>
                  <th>HDFC</th><th>Penalty</th><th>Refund</th><th>Payable</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report, i) => (
                  <tr key={report.id} style={{ animationDelay: `${i * 40}ms` }}>
                    <td>{report.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={report.ownerName} size={38} />
                        <div>
                          <div className="name">{report.ownerName || 'N/A'}</div>
                          {report.noOfBuses > 0 && <div className="sub">{report.noOfBuses} bus{report.noOfBuses > 1 ? 'es' : ''}</div>}
                        </div>
                      </div>
                    </td>
                    <td>{report.contractNumber || 'N/A'}</td>
                    <td>
                      <div title={report.address} style={{ maxWidth: 220 }}>
                        {report.address && report.address.length > 30 ? `${report.address.substring(0, 30)}...` : report.address || 'N/A'}
                      </div>
                    </td>
                    <td><span className="pbo-count">{report.noOfBuses}</span></td>
                    <td><span className="bor-pos">{fmtINR(report.seatBooking)}</span></td>
                    <td><span className="bor-pos">{fmtINR(report.instantBooking)}</span></td>
                    <td><span className="bor-neg">{fmtINR(report.razorpay)}</span></td>
                    <td><span className="bor-neg">{fmtINR(report.tds)}</span></td>
                    <td><span className="bor-neg">{fmtINR(report.hdfc)}</span></td>
                    <td><span className={report.penalty > 0 ? 'bor-neg' : ''}>{fmtINR(report.penalty)}</span></td>
                    <td><span className={report.refund > 0 ? 'bor-neg' : ''}>{fmtINR(report.refund)}</span></td>
                    <td><span className="bor-total">{fmtINR(report.payableAmount)}</span></td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewReport(report.ownerName)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalReports}
        onPage={(p) => { if (p !== currentPage && p >= 1 && p <= totalPages) { setCurrentPage(p); fetchReports(p); } }}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); fetchReports(1); }}
        sizes={[10, 25, 50, 100]} label="bus owners"
      />

      {/* VIEW MODAL */}
      {viewingReport && !isFetchingDetails && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingReport.ownerName} size={52} />
                <div>
                  <h3>{viewingReport.ownerName}</h3>
                  <p>{viewingReport.contractNumber} · {viewingReport.noOfBuses} {viewingReport.noOfBuses === 1 ? 'Bus' : 'Buses'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-form-body">
              {viewingReport.address && (
                <div className="bor-address-line">
                  <Icon name="map" size={14} /> {viewingReport.address}
                </div>
              )}

              <div className="pbo-mini-stats">
                <div><span>Seat Booking</span><b className="bor-pos">{fmtINR(viewingReport.seatBooking)}</b></div>
                <div><span>Instant</span><b className="bor-pos">{fmtINR(viewingReport.instantBooking)}</b></div>
                <div><span>Total Gross</span><b className="bor-total">{fmtINR(viewingReport.seatBooking + viewingReport.instantBooking)}</b></div>
                <div><span>Payable</span><b className="bor-total">{fmtINR(viewingReport.payableAmount)}</b></div>
              </div>

              <div className="prm-section-title">Booking summary</div>
              <div className="bor-detail-grid">
                <div><small>Total Seat Booking</small><b className="bor-pos">{fmtINR(viewingReport.seatBooking)}</b></div>
                <div><small>Total Instant Booking</small><b className="bor-pos">{fmtINR(viewingReport.instantBooking)}</b></div>
                <div><small>Total Gross</small><b className="bor-total">{fmtINR(viewingReport.seatBooking + viewingReport.instantBooking)}</b></div>
              </div>

              <div className="prm-section-title">Deductions</div>
              <div className="bor-detail-grid">
                <div><small>Razorpay</small><b className="bor-neg">{fmtINR(viewingReport.razorpay)}</b></div>
                <div><small>TDS</small><b className="bor-neg">{fmtINR(viewingReport.tds)}</b></div>
                <div><small>HDFC</small><b className="bor-neg">{fmtINR(viewingReport.hdfc)}</b></div>
                <div><small>Penalty</small><b className={viewingReport.penalty > 0 ? 'bor-neg' : ''}>{fmtINR(viewingReport.penalty)}</b></div>
              </div>

              {(viewingReport.cgst > 0 || viewingReport.sgst > 0 || viewingReport.igst > 0) && (
                <>
                  <div className="prm-section-title">Tax summary</div>
                  <div className="bor-detail-grid">
                    {viewingReport.cgst > 0 && <div><small>CGST</small><b>{fmtINR(viewingReport.cgst)}</b></div>}
                    {viewingReport.sgst > 0 && <div><small>SGST</small><b>{fmtINR(viewingReport.sgst)}</b></div>}
                    {viewingReport.igst > 0 && <div><small>IGST</small><b>{fmtINR(viewingReport.igst)}</b></div>}
                  </div>
                </>
              )}

              <div className="prm-section-title">Refund</div>
              <div className="bor-detail-grid">
                <div><small>Refund to Customer</small><b className={viewingReport.refund > 0 ? 'bor-neg' : ''}>{fmtINR(viewingReport.refund)}</b></div>
              </div>

              <div className="bor-total-block">
                <div><small>Total Payable Amount</small><b className="bor-total">{fmtINR(viewingReport.payableAmount)}</b></div>
              </div>

              {viewingReport.perBus && viewingReport.perBus.length > 0 && (
                <>
                  <div className="prm-section-title">Per bus breakdown ({viewingReport.perBus.length} buses)</div>
                  <div className="prm-table-wrap" style={{ maxHeight: 260, overflowY: 'auto' }}>
                    <table className="prm-table">
                      <thead>
                        <tr><th>Bus</th><th>Registration</th><th>Type</th><th>Payable</th></tr>
                      </thead>
                      <tbody>
                        {viewingReport.perBus.map((bus, idx) => (
                          <tr key={idx}>
                            <td>{bus.busDetails || 'N/A'}</td>
                            <td>{bus.busRegistration || 'N/A'}</td>
                            <td><span className={`prm-status ${bus.busType === 'AC' ? 'active' : 'inactive'}`}>{bus.busType}</span></td>
                            <td><span className="bor-total">{fmtINR(bus.payableAmount)}</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={closeViewModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DETAILS LOADING */}
      {viewingReport && isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusOwnerReport;